import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from 'moment';

import { CheckAmbulanciaService } from '../../services/check-ambulancia.service';

@Component({
  selector: 'app-checkambulanciaprint',
  templateUrl: './checkambulanciaprint.component.html',
  styleUrls: ['./checkambulanciaprint.component.css']
})
export class CheckambulanciaprintComponent implements OnInit {
  public checklist = {
    'cliente': {
      'cliente_nome': ''
    },
    'unidade': {
      'unidade_nome': ''
    },
    'profissional': {
      'profissional_nome': ''
    },
    'veiculo': {
      'veiculo_placa': ''
    },
    'check_ambulancia_data':'',
    'check_ambulancia_turno':'',
    'check_ambulancia_justificativa':'',
    'check_ambulancia_quilometragem':'',
    'check_ambulancia_combustivel':'',
    'check_ambulancia_oleo_motor':'',
    'check_ambulancia_oleo_motor_obs':'',
    'check_ambulancia_agua_radiador':'',
    'check_ambulancia_agua_radiador_obs':'',
    'check_ambulancia_fluido_freio':'',
    'check_ambulancia_fluido_freio_obs':'',
    'check_ambulancia_injetor_agua':'',
    'check_ambulancia_injetor_agua_obs':'',
    'check_ambulancia_freio_de_mao':'',
    'check_ambulancia_freio_de_mao_obs':'',
    'check_ambulancia_partida':'',
    'check_ambulancia_partida_obs':'',
    'check_ambulancia_luz_re':'',
    'check_ambulancia_luz_re_obs':'',
    'check_ambulancia_luz_freio':'',
    'check_ambulancia_luz_freio_obs':'',
    'check_ambulancia_sirene':'',
    'check_ambulancia_sirene_obs':'',
    'check_ambulancia_buzina':'',
    'check_ambulancia_buzina_obs':'',
    'check_ambulancia_ac':'',
    'check_ambulancia_ac_obs':'',
    'check_ambulancia_ilu_salao':'',
    'check_ambulancia_ilu_salao_obs':'',
    'check_ambulancia_tomadas':'',
    'check_ambulancia_tomadas_obs':'',
    'check_ambulancia_cinto':'',
    'check_ambulancia_cinto_obs':'',
    'check_ambulancia_cones':'',
    'check_ambulancia_cones_obs':'',
    'check_ambulancia_extintor':'',
    'check_ambulancia_extintor_obs':'',
    'check_ambulancia_macaco':'',
    'check_ambulancia_macaco_obs':'',
    'check_ambulancia_chave_roda':'',
    'check_ambulancia_chave_roda_obs':'',
    'check_ambulancia_triangulo':'',
    'check_ambulancia_triangulo_obs':'',
    'check_ambulancia_radio':'',
    'check_ambulancia_radio_obs':'',
    'check_ambulancia_gps':'',
    'check_ambulancia_gps_obs':'',
    'check_ambulancia_celular':'',
    'check_ambulancia_celular_obs':'',
    'check_ambulancia_carregador':'',
    'check_ambulancia_carregador_obs':'',
    'check_ambulancia_antena':'',
    'check_ambulancia_antena_obs':'',
    'check_ambulancia_pneus':'',
    'check_ambulancia_pneus_obs':'',
    'check_ambulancia_estepe':'',
    'check_ambulancia_estepe_obs':'',
    'check_ambulancia_portas':'',
    'check_ambulancia_portas_obs':'',
    'check_ambulancia_vidros':'',
    'check_ambulancia_vidros_obs':'',
    'check_ambulancia_lavada':'',
    'check_ambulancia_lavada_obs':'',
    'check_ambulancia_giroflex': '',
    'check_ambulancia_giroflex_obs': '',
    'check_ambulancia_estrobo': '',
    'check_ambulancia_estrobo_obs': '',
    'check_ambulancia_retrovisores': '',
    'check_ambulancia_retrovisores_obs': '',
    'check_ambulancia_farois': '',
    'check_ambulancia_farois_obs': '',
    'check_ambulancia_piscas': '',
    'check_ambulancia_piscas_obs': '',
    'check_ambulancia_lanterna_tras': '',
    'check_ambulancia_lanterna_tras_obs': '',
    'check_ambulancia_palheta': '',
    'check_ambulancia_palheta_obs': '',
    'check_ambulancia_luz_placa': '',
    'check_ambulancia_luz_placa_obs': '',
    'check_ambulancia_cilindro_o2': '',
    'check_ambulancia_cilindro_o2_obs': '',
    'check_ambulancia_chave_o2': '',
    'check_ambulancia_chave_o2_obs': '',
    'check_ambulancia_maca_rigida': '',
    'check_ambulancia_maca_rigida_obs': '',
    'check_ambulancia_maca_retratil': '',
    'check_ambulancia_maca_retratil_obs': '',
    'check_ambulancia_cartao_abast': '',
    'check_ambulancia_cartao_abast_obs': '',
    'check_ambulancia_obs': '',
    'check_ambulancia_intercorrencia': '',
};

public loHtml;

  constructor(
    private route: ActivatedRoute,
    private checkAmbulanciaSvc: CheckAmbulanciaService,
    private router: Router
    ) { }

  voltar(){
    this.router.navigate(['home/checklist/']);
  }
    
  ngOnInit() {

    let html;

    this.route.params.subscribe( params => {
			if (params.id) {

				this.checkAmbulanciaSvc.getCheckAmbulancia(params.id).then((data: any) => {
          data.check_ambulancia_data = moment(data.check_ambulancia_data, 'YYYY-MM-DD').format('DD/MM/YYYY');
          this.checklist = data;

          let html = "<h3>CHECK-LIST CHRONOS FROTA</h3>"


          let check_ambulancia_turno;
          if(this.checklist.check_ambulancia_turno == "D"){
            check_ambulancia_turno = "Diurno";
          }else{
            check_ambulancia_turno = "Noturno";
          }

          html += " <div class='' id='' style='width:650px;'> <div> ";
          html += "   <div class='panel-heading border-bottom'>";
          html += "     <h4>Turno</h4> ";
          html += "   </div> ";
          html += "   <div class='panel-body'> ";
          html += "     <div class='row'> ";
          html += "       <div class='col-xs-4'> ";
          html += "         <div> ";
          html += "           <label>Data turno: " + this.checklist.check_ambulancia_data + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='col-xs-4 col-xs-offset-4'> ";
          html += "         <div> ";
          html += "           <label>Periodo: " + check_ambulancia_turno + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "     <div class='row'> ";
          html += "       <div class='col-xs-12'> ";
          html += "         <div> ";
          html += "           <label>Justificativa: " + this.formatNull(this.checklist.check_ambulancia_justificativa); + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "   </div> ";
          html += " </div> ";
          html += " <!-- LOCALIZACAO BEGIN--> ";
          html += " <div> ";
          html += "   <div class='panel-heading border-bottom'> ";
          html += "     <h4>Localização</h4> ";
          html += "   </div> ";
          html += "   <div class='panel-body'> ";
          html += "     <div class='row'> ";
          html += "       <div class='col-xs-12'> ";
          html += "         <div> ";
          html += "           <label>Central: " + this.checklist.cliente.cliente_nome + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "     <div class='row'> ";
          html += "       <div class='col-xs-12'> ";
          html += "         <div> ";
          html += "           <label>Unidade/base: " + this.checklist.unidade.unidade_nome + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "     <div class='row'> ";
          html += "       <div class='col-xs-8'> ";
          html += "         <div> ";
          html += "           <label>Profissional: " + this.checklist.profissional.profissional_nome + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "   </div> ";
          html += " </div> ";
          html += " <!-- LOCALIZACAO END--> ";
          html += " <!-- VEICULO BEGIN-->";
          html += " <div>";
          html += "   <div class='panel-heading border-bottom'>";
          html += "     <h4>Veículo</h4>";
          html += "   </div>";
          html += "   <div class='panel-body'>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Veículo: " + this.checklist.veiculo.veiculo_placa + "</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-5'>";
          html += "         <div>";
          html += "           <label>Quilometragem: " + this.mascaraKm(this.checklist.check_ambulancia_quilometragem) + "</label>";
          html += "         </div>";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-12'>";
          html += "         <div>";
          html += "           <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_obs) + "";
          html += "         </div>";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <label>Nível combustível:</label>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         <label>" + this.formatDataCombustivel(this.checklist.check_ambulancia_combustivel) + "</label>";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Ambulância lavada:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         <label>";
          html += "           "+ this.formatDataSimNao(this.checklist.check_ambulancia_lavada) + "";
          html += "         </label>";
          html += "       </div>";
          html += "       <div class='col-xs-7'>";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_lavada_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "   </div>";
          html += " </div>";
          html += " <!-- ------------------------------- --> ";          
          html += "</div>";

          html += " <div>";
          html += "   <div class='panel-heading'>";
          html += "     <h4>Mecânica</h4>";
          html += "   </div>";
          html += "   <div class='panel-body'>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Óleo do motor:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_ambulancia_oleo_motor) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_oleo_motor_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Água do radiador:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_ambulancia_agua_radiador) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7'>";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_agua_radiador_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Fluído de freio:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_ambulancia_fluido_freio) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_fluido_freio_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Palheta do limpador de para-brisa:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " +this.formatDataSimNao(this.checklist.check_ambulancia_palheta) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_palheta_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Injetor de água do para-brisa: </label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_ambulancia_injetor_agua) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_injetor_agua_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "     <div class='row'>";
          html += "       <div class='col-xs-4'>";
          html += "         <div>";
          html += "           <label>Freio de mão: </label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_ambulancia_freio_de_mao) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_freio_de_mao_obs) + "";
          html += "       </div>";
          html += "     </div>";
          html += "   </div>";
          html += " </div>";

          html += "<!-- ELETRICO  -->";
          html += "<div>";
          html += "  <div class='panel-heading'>";
          html += "    <h4>Elétrico</h4>";
          html += "  </div>";
          html += "  <div class='panel-body'>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Faróis: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        " + this.formatDataSimNao(this.checklist.check_ambulancia_farois)  + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' >";
          html += "        <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_farois_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Piscas: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        " + this.formatDataSimNao(this.checklist.check_ambulancia_piscas) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' >";
          html += "        <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_piscas_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Partida: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_partida)  + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' >";
          html += "        <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_partida_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Luz de ré: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        " +this.formatDataSimNao(this.checklist.check_ambulancia_luz_re) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' >";
          html += "        <b>Obs.:</b> " + this.formatNull(this.checklist.check_ambulancia_luz_re_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Luz de freio: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_luz_freio)  + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_luz_freio_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Luz lanterna traseira:";
          html += "          </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_lanterna_tras) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' >";
          html += "        <b>Obs.:</b> "  + this.formatNull(this.checklist.check_ambulancia_lanterna_tras_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Luz de placa:";
          html += "          </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_luz_placa) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_luz_placa_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div> <label>Sirene: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_sirene)  + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_sirene_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Buzina: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_buzina) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_buzina_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Giroflex: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_giroflex) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_giroflex_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Estrobo: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_estrobo) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7' > <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_estrobo_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Ar condicionado: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_ac) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7'> <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_ac_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Iluminação do salão: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_ilu_salao) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7'> <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_ilu_salao_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "    <div class='row'>";
          html += "      <div class='col-xs-4'>";
          html += "        <div>";
          html += "          <label>Tomadas: </label>";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='col-xs-1'>";
          html += "        "  + this.formatDataSimNao(this.checklist.check_ambulancia_tomadas) + "";
          html += "      </div>";
          html += "      <div class='col-xs-7'> <b>Obs.:</b>";
          html += "        "  + this.formatNull(this.checklist.check_ambulancia_tomadas_obs) + "";
          html += "      </div>";
          html += "    </div>";
          html += "  </div>";
          html += "</div>";
          html += "<!-- ELETRICO  FIM-->";
          html += "<!-- EQUIPAMENTOS -->";
          html += "  <div>";
          html += "    <div class='panel-heading border-bottom'>";
          html += "      <h4>Equipamentos</h4>";
          html += "    </div>";
          html += "    <div class='panel-body'>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Cinto de segurança: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_cinto) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_cinto_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_cinto_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Cones: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_cones) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_cones_obs) + "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Extintor: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_extintor) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_extintor_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Macaco: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_macaco) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_macaco_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_macaco_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Chave de roda: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_chave_roda) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_chave_roda_obs'>";
          html += "          <b>Obs.:</b>  "  + this.formatNull(this.checklist.check_ambulancia_chave_roda_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Triângulo: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_triangulo) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_triangulo_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_triangulo_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Rádio comunicador:</label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_radio) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_radio_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_radio_obs) + "";
          html += "        </div>";
          html += "";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Cilindro de O2: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_cilindro_o2) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_cilindro_o2_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_cilindro_o2_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Chave do O2: </label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_chave_o2) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_chave_o2_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_chave_o2_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Maca rígida:</label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_maca_rigida) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_maca_rigida_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_maca_rigida_obs) + "";
          html += "        </div>";
          html += "      </div>";
          html += "      <div class='row'>";
          html += "        <div class='col-xs-4'>";
          html += "          <div>";
          html += "            <label>Maca retrátil:</label>";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='col-xs-1'>";
          html += "          " + this.formatDataSimNao(this.checklist.check_ambulancia_maca_retratil) + "";
          html += "        </div>";
          html += "        <div class='col-xs-7' *ngIf='checklist.check_ambulancia_maca_retratil_obs'> <b>Obs.:</b>";
          html += "           "  + this.formatNull(this.checklist.check_ambulancia_maca_retratil_obs)+ "";
          html += "        </div>";
          html += "      </div>";
          html += "    </div>";
          html += "  </div>";
          html += "  <!-- EQUIPAMENTOS FIM-->";
          html += "    <!-- ACESSORIOS -->";
          html += "    <div style=''>";
          html += "      <div class='panel-heading'>";
          html += "        <h4>Acessórios</h4>";
          html += "      </div>";
          html += "      <div class='panel-body'>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Cartão de abastecimento: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_cartao_abast)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_cartao_abast_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_cartao_abast_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>GPS: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_gps)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_gps_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_gps_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Celular: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_celular)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_celular_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_celular_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Carregador: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_carregador)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_carregador_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_carregador_obs) + "'";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Retrovisores: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_retrovisores)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_retrovisores_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_retrovisores_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Antena do radio: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_antena)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_antena_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_antena_obs) + '';
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Pneus: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_pneus)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_pneus_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_pneus_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Estepe: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_estepe)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_estepe_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_estepe_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Portas: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_portas)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_portas_obs'> <b>Obs.:</b>";
          html += "           " + this.formatNull(this.checklist.check_ambulancia_portas_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-4'>";
          html += "            <div>";
          html += "              <label>Vidros: </label>";
          html += "            </div>";
          html += "          </div>";
          html += "          <div class='col-xs-1'>";
          html += "            " + this.formatDataSimNao(this.checklist.check_ambulancia_vidros)  + ""; 
          html += "          </div>";
          html += "          <div class='col-xs-7' *ngIf='checklist.check_ambulancia_vidros_obs'> <b>Obs.:</b>";
          html += "            " + this.formatNull(this.checklist.check_ambulancia_vidros_obs) + "";
          html += "          </div>";
          html += "        </div>";
          html += "        <div class='row'>";
          html += "          <div class='col-xs-12'>";
          html += "            <div>";
          html += "              <label>Intercorrência:</label>";
          html += "              " + this.formatNull(this.checklist.check_ambulancia_intercorrencia) + "";
          html += "            </div>";
          html += "          </div>";
          html += "        </div>";
          html += "      </div>";
          html += "    </div>   ";       
          
          



          //document.body.innerHTML = html;   
          //sidebar
          document.getElementById("sidebar").style.display = "none";
          //document.getElementById('container-fluid').remove();
          //document.getElementById("container-fluid").style.display = "none";
          //document.getElementById('sidebar').remove();
          document.getElementById('imprimir_checklist').innerHTML = html;
          window.print();
          document.getElementById("sidebar").style.display = "block";

				});
       

     	}
		});





   // this.imprimirBody();
   // setTimeout(this.imprimirBody, 1000000);

  }

  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}

		}

	  }

  formatNull(obj){

    if(obj == null){
      obj = "";
    }

    return obj;
  }

  imprimirBody(){
    let printContents = document.getElementById("imprimir_checklist").innerHTML;
    let originalContents = document.body.innerHTML;   
    document.body.innerHTML = printContents;   
    window.print();

  }


  formatDataSimNao(data){
    switch(data){
      case 'S':
        return 'Sim';
      case 'N':
        return 'Não';
      default:
        return ''; 
    }
  }

  formatDataCombustivel(data){
    switch(data){
      case 'CH':
        return 'Cheio';
      case '34':
        return '3/4';
      case '12':
        return '1/2';
      case '14':
        return '1/4';
      case 'ND':
        return '0';
      default:
        return '';
    }
  }

}
